var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loadError
    ? _c(
        "contentBox",
        { attrs: { loading: !_vm.permitLoaded, mainId: "permit" } },
        [
          _vm.permit
            ? _c(
                "contentTitle",
                { attrs: { label: "PERMIT", close: _vm.routeClose } },
                [
                  _c(
                    "h2",
                    { staticClass: "text-white font-weight-light pb-2" },
                    [_vm._v(_vm._s(_vm.permit.typeRaw))]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.permit
            ? _c(
                "contentBody",
                [
                  _vm.permit
                    ? _c("contentActions", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-light btn-sm",
                            class: { active: _vm.shareShown === true },
                            on: { click: _vm.share }
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons md-18",
                                attrs: { title: "center map on zoning" }
                              },
                              [_vm._v("share")]
                            ),
                            _vm._v(" \n\t\t\t\tShare\n\t\t\t")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-light btn-sm",
                            on: { click: _vm.zoomTo }
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons md-18",
                                attrs: { title: "center map on zoning" }
                              },
                              [_vm._v("place")]
                            ),
                            _vm._v(" \n\t\t\t\tCenter\n\t\t\t")
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shareShown
                    ? _c("share", {
                        attrs: { link: _vm.location },
                        on: { close: _vm.share }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "p-3" }, [
                    _c("div", { staticClass: "category-body" }, [
                      _c("div", { staticClass: "category" }, [
                        _c("div", { staticClass: "category-title" }, [
                          _vm._v("DETAILS")
                        ]),
                        _vm._v(" "),
                        _vm.permit.projectName !== null
                          ? _c("div", { staticClass: "property-row" }, [
                              _c("label", [_vm._v("Project name")]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "property-value-right" },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.permit.projectName) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.permit.projectId !== null
                          ? _c("div", { staticClass: "property-row" }, [
                              _c("label", [_vm._v("Project ID")]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "property-value-right" },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.permit.projectId) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.permit.contractor &&
                        _vm.permit.contractor.companyName !== null
                          ? _c("div", { staticClass: "property-row" }, [
                              _c("label", [_vm._v("Contractor")]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "property-value-right" },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.permit.contractor.companyName
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.validDate(_vm.permit.appliedDate)
                          ? _c("div", { staticClass: "property-row" }, [
                              _c("label", [_vm._v("Applied")]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "property-value-right" },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm._f("longDate")(
                                          _vm.permit.appliedDate
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.validDate(_vm.permit.issuedDate)
                          ? _c("div", { staticClass: "property-row" }, [
                              _c("label", [_vm._v("Issued")]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "property-value-right" },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm._f("longDate")(
                                          _vm.permit.issuedDate
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.validDate(_vm.permit.completedDate)
                          ? _c("div", { staticClass: "property-row" }, [
                              _c("label", [_vm._v("Completed")]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "property-value-right" },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm._f("longDate")(
                                          _vm.permit.completedDate
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.permit.description !== null
                        ? _c("div", { staticClass: "category" }, [
                            _c("div", { staticClass: "category-title" }, [
                              _vm._v("DESCRIPTION")
                            ]),
                            _vm._v(" "),
                            !_vm.permit.unlocked && _vm.parcel
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "lock-block mt-2 mb-2",
                                    on: { click: _vm.unlockParcel }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "lock-icon-box" },
                                      [
                                        _c(
                                          "i",
                                          {
                                            staticClass: "material-icons md-36"
                                          },
                                          [_vm._v("lock")]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "lock-text" }, [
                                      _c(
                                        "h5",
                                        { staticClass: "mb-0 text-white" },
                                        [
                                          _vm._v(
                                            "Unlock to view permit description"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "h5",
                                        {
                                          staticClass:
                                            "mb-0 font-weight-light text-light"
                                        },
                                        [
                                          _vm._v(
                                            "$" +
                                              _vm._s(
                                                _vm.plans.parcelUnlock.price
                                              ) +
                                              " to unlock all info for this permit's parcel"
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              : !_vm.permit.unlocked
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "lock-block mt-2 mb-2",
                                    on: { click: _vm.unlock }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "lock-icon-box" },
                                      [
                                        _c(
                                          "i",
                                          {
                                            staticClass: "material-icons md-36"
                                          },
                                          [_vm._v("lock")]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "lock-text" }, [
                                      _c(
                                        "h5",
                                        { staticClass: "mb-0 text-white" },
                                        [
                                          _vm._v(
                                            "Unlock to view permit description"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "h5",
                                        {
                                          staticClass:
                                            "mb-0 font-weight-light text-light"
                                        },
                                        [
                                          _vm._v(
                                            "$" +
                                              _vm._s(_vm.plans.dayPass.price) +
                                              " to unlock all info on Scoutred for 24 hours"
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              : _c("div", { staticClass: "property-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "text-description" },
                                    [_vm._v(_vm._s(_vm.permit.description))]
                                  )
                                ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permit.jurisdictionPermitId
                        ? _c("div", { staticClass: "category" }, [
                            _c("div", { staticClass: "category-title" }, [
                              _vm._v("REFERENCES")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "property-row" }, [
                              _c(
                                "label",
                                { staticClass: "mb-0 font-weight-light" },
                                [_vm._v("Source")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "property-value-right" },
                                [
                                  this.permit && this.permit.link
                                    ? _c(
                                        "a",
                                        {
                                          attrs: {
                                            target: "_blank",
                                            href: _vm.jurisdictionPermitURL(
                                              this.permit
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t#" +
                                              _vm._s(
                                                this.permit.jurisdictionPermitId
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t"
                                          ),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "material-icons md-12"
                                            },
                                            [_vm._v("open_in_new")]
                                          )
                                        ]
                                      )
                                    : _c("span", [
                                        _vm._v(
                                          "#" +
                                            _vm._s(
                                              this.permit.jurisdictionPermitId
                                            )
                                        )
                                      ])
                                ]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.parcel
                        ? _c("div", { staticClass: "category" }, [
                            _c("div", { staticClass: "category-title" }, [
                              _vm._v("PARCEL")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "property-row" }, [
                              _c("label", [_vm._v("Address")]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "property-value-right" },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm._f("address")(_vm.parcel)) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "property-row pt-0" }, [
                              _c(
                                "div",
                                { staticClass: "property-value-right" },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.parcelSub) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _vm.permit.apnFmt !== null
                              ? _c("div", { staticClass: "property-row" }, [
                                  _c("label", [_vm._v("APN")]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "property-value-right" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "javascript:" },
                                          on: {
                                            click: function($event) {
                                              return _vm.parcelGo(
                                                $event,
                                                _vm.permit.parcelId
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t" +
                                              _vm._s(_vm.parcel.apnFmt) +
                                              "\n\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm.permitsOther && _vm.permitsOther.length > 0
                      ? _c(
                          "div",
                          { staticClass: "bg-light p-2 pb-3" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "pt-1 mx-2 pb-2 font-weight-bold font-12 text-light-gray"
                              },
                              [
                                _vm._v(
                                  "OTHER PERMITS FROM THIS PARCEL (" +
                                    _vm._s(_vm.permitsOther.length) +
                                    ")"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.permitsOther, function(permit, index) {
                              return _c(
                                "div",
                                {
                                  staticClass: "card mb-2 p-2 pb-3",
                                  on: {
                                    click: function($event) {
                                      return _vm.permitClick($event, permit)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "category-title text-uppercase"
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t" +
                                          _vm._s(permit.typeRaw) +
                                          " \n\t\t\t\t\t\t"
                                      ),
                                      _vm.getStatusIsNew(permit)
                                        ? _c(
                                            "sup",
                                            { staticClass: "text-red" },
                                            [_vm._v("New")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "float-right" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: _vm.jurisdictionPermitURL(
                                                  permit
                                                ),
                                                target: "_blank"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t#" +
                                                  _vm._s(
                                                    permit.jurisdictionPermitId
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              ),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "material-icons md-12"
                                                },
                                                [_vm._v("open_in_new")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "pt-2" }, [
                                    _vm.parcel && _vm.parcel.apnFmt
                                      ? _c(
                                          "div",
                                          { staticClass: "property-row" },
                                          [
                                            _c("label", [_vm._v("Parcel APN")]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "property-value-right"
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: "javascript:"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.parcelGo(
                                                          $event,
                                                          permit.parcelId
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.parcel.apnFmt
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    permit.projectName !== null
                                      ? _c(
                                          "div",
                                          { staticClass: "property-row" },
                                          [
                                            _c("label", [
                                              _vm._v("Project name")
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "property-value-right"
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t" +
                                                    _vm._s(permit.projectName) +
                                                    "\n\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    permit.projectId !== null
                                      ? _c(
                                          "div",
                                          { staticClass: "property-row" },
                                          [
                                            _c("label", [_vm._v("Project ID")]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "property-value-right"
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t" +
                                                    _vm._s(permit.projectId) +
                                                    "\n\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    permit.contractor &&
                                    permit.contractor.companyName !== null
                                      ? _c(
                                          "div",
                                          { staticClass: "property-row" },
                                          [
                                            _c("label", [_vm._v("Contractor")]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "property-value-right"
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      permit.contractor
                                                        .companyName
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "property-row" }, [
                                      _c("label", [_vm._v("Status")]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "property-value-right" },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t" +
                                              _vm._s(_vm.getStatus(permit)) +
                                              " on " +
                                              _vm._s(_vm.getStatusDate(permit))
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    permit.description !== null
                                      ? _c(
                                          "div",
                                          { staticClass: "property-row" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-description"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.descriptionShort(
                                                      permit.description
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4828b09d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4828b09d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/permit/permit-full.vue
// module id = null
// module chunks = 